import { Routes, Route } from 'react-router-dom';
import { Layout, SidebarLayout } from './Utils/layout';

import PersistLogin from './Utils/persistLogin';
import RequireAuth from './Utils/requireAuth';
import ROLES from './Utils/roles';

// Pages
import HomePage from './Pages/home';
import LoginPage from './Pages/loginPage';
import RegisterPage from './Pages/registerPage';
import UnauthorizedPage from './Pages/unauthorizedPage';
import ForgotPasswordPage from './Pages/forgotPasswordPage';
import ResetPasswordPage from './Pages/resetPasswordPage';
import NotFoundPage from './Pages/notFoundPage';
import VerifyPage from './Pages/verifyPage';
import NotVerifiedPage from './Pages/notVerifiedPage';
import ProfilePage from './Pages/profilePage';
import ManageMembersPage from './Pages/manageMembersPage';
import ManageWaitlistPage from './Pages/manageWaitlistPage';
import ContractPage from './Pages/contractPage';
import GalleryPage from './Pages/galleryPage';
import GalleryDetailsPage from './Pages/galleryDetailsPage';
import ManageNftPage from './Pages/manageNftsPage';
import NewsletterPage from './Pages/newsletterPage';

const pageHandler = () => (
  <Routes>
    <Route path="/" element={<Layout />}>
      {/* Public Routes */}
      <Route path="login" element={<LoginPage />} />
      <Route path="register" element={<RegisterPage />} />
      <Route path="unauthorized" element={<UnauthorizedPage />} />
      <Route path="forgot_password" element={<ForgotPasswordPage />} />
      <Route path="reset_password/:id/:token" element={<ResetPasswordPage />} />
      <Route path="verify" element={<VerifyPage />} />

      {/* Protected Routes */}
      <Route element={<PersistLogin />}>
        <Route element={<SidebarLayout />}>
          <Route path="notverified" element={<NotVerifiedPage />} />
          <Route element={<RequireAuth allowedRoles={[ROLES.User, ROLES.Team, ROLES.Admin]} />}>
            <Route path="/" element={<HomePage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="gallery" element={<GalleryPage />} />
            <Route path="gallery/:id" element={<GalleryDetailsPage />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[ROLES.Team, ROLES.Admin]} />}>
            <Route path="manageWaitlist" element={<ManageWaitlistPage />} />
            <Route path="manageNfts" element={<ManageNftPage />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
            <Route path="manage" element={<ManageMembersPage />} />
            <Route path="contract" element={<ContractPage />} />
            <Route path="newsletter" element={<NewsletterPage />} />
          </Route>
        </Route>
      </Route>

      {/* 404 Route */}
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  </Routes>
);

export default pageHandler;
